import { Component, OnInit } from '@angular/core';
import { MaintenanceTypeService } from '../../core/services/maintenance-type.service';
import { CommonModule } from '@angular/common';
import { TableComponent } from '../../shared/components/table/table.component';
import { RouterModule } from '@angular/router';
import { NewButtonComponent } from '../../shared/components/new-button/new-button.component';
import { ConfirmPopupComponent } from '../../shared/components/confirm-popup/confirm-popup.component';
import { MaintenanceType } from '../../core/models/maintenance-type.model';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MaintenanceTypeDetailComponent } from '../maintenance-type-detail/maintenance-type-detail.component';

@Component({
  selector: 'app-maintenance-type-list',
  templateUrl: './maintenance-type-list.component.html',
  styleUrls: ['./maintenance-type-list.component.scss'],
  standalone: true,
  imports: [
    TableComponent,
    RouterModule,
    NewButtonComponent,
    ConfirmPopupComponent,
    CommonModule,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    MatButtonModule,
    MaintenanceTypeDetailComponent,
  ],
})
export class MaintenanceTypeListComponent implements OnInit {
  maintenanceTypes: MaintenanceType[] = [];
  flattenedData: any[] = [];
  maintenanceTypeToDelete: MaintenanceType | null = null;
  selectedMaintenanceType: MaintenanceType | null = null;
  tableColumns = [
    { header: 'ID', field: 'id' },
    { header: 'Nombre', field: 'name' },
    { header: 'Tipo de Vista', field: 'viewTypeName' },
    { header: 'Estado', field: 'disabled' },
  ];

  constructor(private maintenanceTypeService: MaintenanceTypeService) {}

  ngOnInit(): void {
    this.getMaintenanceTypes();
  }

  getMaintenanceTypes(): void {
    this.maintenanceTypeService.getMaintenanceTypes().subscribe({
      next: maintenanceTypes => {
        this.maintenanceTypes = maintenanceTypes;
        this.flattenData();
      },
      error: error => {
        console.error('Error al obtener los tipos de mantenimiento:', error);
      },
    });
  }

  flattenData(): void {
    this.flattenedData = this.maintenanceTypes.map(item => ({
      id: item.id,
      name: item.name || '',
      viewTypeName: item.viewType.name || '',
      disabled: item.disabled,
      viewType: item.viewType,
    }));
  }

  confirmDelete(maintenanceType: MaintenanceType): void {
    this.maintenanceTypeToDelete = maintenanceType;
  }

  onDeleteConfirm(): void {
    if (this.maintenanceTypeToDelete && this.maintenanceTypeToDelete.id !== undefined) {
      this.maintenanceTypeService
        .deleteMaintenanceType(this.maintenanceTypeToDelete.id)
        .subscribe(() => {
          this.getMaintenanceTypes();
          this.maintenanceTypeToDelete = null;
        });
    }
  }

  onDeleteCancel(): void {
    this.maintenanceTypeToDelete = null;
  }

  toggleMaintenanceTypeStatus(maintenanceType: MaintenanceType): void {
    maintenanceType.disabled = !maintenanceType.disabled;
    this.maintenanceTypeService.disabledMaintenanceType(maintenanceType).subscribe(() => {
      this.getMaintenanceTypes();
    });
  }

  selectMaintenanceType(maintenanceType: MaintenanceType): void {
    this.selectedMaintenanceType = maintenanceType;
  }

  closeMaintenanceTypeDetail(): void {
    this.selectedMaintenanceType = null;
  }
}
